module.exports = __webpack_public_path__ + "img/notify2.91b77e8c.png";